"use client";

import { matchingCopy } from "@/components/matching/matching-copy";

/**
 * `birth` computes both charts from birth details; `naam` derives each Moon
 * nakshatra from a confirmed naam-akshar when the birth time is unknown. They
 * are different inputs to the same question, not two products — hence one page
 * and one toggle, never a second URL (rule 66).
 */
export type MatchingMode = "birth" | "naam";

export function MatchingModeToggle({
  mode,
  language,
  onChange,
}: {
  mode: MatchingMode;
  language: "en" | "hi";
  onChange: (mode: MatchingMode) => void;
}) {
  const copy = matchingCopy(language);
  const options: { value: MatchingMode; label: string }[] = [
    { value: "birth", label: copy.modeBirth },
    { value: "naam", label: copy.modeNaam },
  ];
  return (
    <div className="mx-auto mb-4 flex max-w-md gap-2" role="group">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={mode === option.value}
          className={`flex-1 rounded-full border px-3 py-2 text-body-small ${
            mode === option.value
              ? "border-ish-accent font-semibold text-intent-brand"
              : "border-ish-border text-ish-text-muted"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
